<script lang="ts">
    import {Button, Input, Label, Modal} from "flowbite-svelte";
    import AddressDisplay from "$lib/components/AddressDisplay.svelte";
    import {HomeSolid, MailBoxSolid} from "flowbite-svelte-icons";
    import InfoBox from "$items/InfoBox.svelte";
    import {put} from "$lib/api";
    import {allUnits} from "$lib/stores/unit";

    export let open = false

    export let unit: any

    $: {
        if(unit && !unit.address){
            unit.address = {
                name: unit.name,
                shortKey: unit?.shortKey || '',
                street: '',
                zip: '',
                number: '',
                place: '',
                country: 'Deutschland'
            }
        }

    }

    const updateUnit = async () => {
        unit = await put('/unit/' + unit.id, unit)
        $allUnits = [...$allUnits.filter(x => x.id !== unit.id), unit]
        open = false;
    }
</script>

<Modal bind:open title={unit?.name}>
    {#if unit}
        <form on:submit|preventDefault={updateUnit}>
            <h3 class="text-lg text-neutral-600 mb-3">Basiseigenschaften</h3>
            <div class="flex gap-3">
                <Label class="space-y-2 flex-1">
                    <span>Name</span>
                    <Input required bind:value={unit.name}/>
                </Label>
                <Label class="space-y-2">
                    <span>Shortcode</span>
                    <Input required bind:value={unit.shortKey}/>
                </Label>
            </div>

            <div class="grid gap-3 grid-cols-2 mt-3">
                <Label class="space-y-2">
                    <span>Telefon</span>
                    <Input required bind:value={unit.phoneNumber}/>
                </Label>
                <Label class="space-y-2">
                    <span>Email</span>
                    <Input required type="email" bind:value={unit.email}/>
                </Label>
            </div>
            {#if unit?.address}
                <div class="flex gap-3 mt-3">
                    <Label class="space-y-2 flex-1">
                        <span>Straße</span>
                        <Input bind:value={unit.address.street}/>
                    </Label>
                    <Label class="space-y-2 ">
                        <span>Hausnummer</span>
                        <Input bind:value={unit.address.number}/>
                    </Label>
                </div>
                <div class="flex gap-3 mt-3">
                    <Label class="space-y-2">
                        <span>PLZ</span>
                        <Input bind:value={unit.address.zip}/>
                    </Label>
                    <Label class="space-y-2 flex-1">
                        <span>Ort</span>
                        <Input bind:value={unit.address.place}/>
                    </Label>
                </div>
                <Label class="space-y-2 mt-3">
                    <span>Land</span>
                    <Input bind:value={unit.address.country}/>
                </Label>
            {/if}


            <div class="flex mt-3 justify-end">
                <Button type="submit">Speichern</Button>
            </div>
        </form>

    {/if}
</Modal>